import AxiosInstance from '@/services/AxiosInstance.js'

export interface StartCheckPlan {
  shouldStagger: boolean
  delaySeconds: number
  staggerEndsAt: number | null
}

const START_CHECK_TIMEOUT_MS = 2000

const failOpen: StartCheckPlan = {
  shouldStagger: false,
  delaySeconds: 0,
  staggerEndsAt: null
}

export async function startCheck(
  classId: number,
  subtestIndex: number,
  questionIndex: number
): Promise<StartCheckPlan> {
  try {
    const request = AxiosInstance.post(`${_API_BASE_URL_}/screening/room/start-check`, {
      classId,
      subtestIndex,
      questionIndex
    })
    const timeout = new Promise<never>((_, reject) =>
      setTimeout(() => reject(new Error('start-check timeout')), START_CHECK_TIMEOUT_MS)
    )
    const response: any = await Promise.race([request, timeout])
    const data = response?.data ?? response
    return {
      shouldStagger: !!data?.shouldStagger,
      delaySeconds: data?.delaySeconds || 0,
      staggerEndsAt: data?.staggerEndsAt ?? null
    }
  } catch (error) {
    console.warn('start-check failed open', error)
    return { ...failOpen }
  }
}
